/**
 * @file: This file holds the controller of the Style guide page.
 *
 * The page shows every shared element with the real style, so a developer
 * copies the markup from here and a designer changes one token and sees the
 * change in every sample. The page reads no data from the server. The
 * controller therefore holds the catalogue tables and nothing else.
 */

import {
  COLOUR_TOKENS,
  FONT_TOKENS,
  TYPE_TOKENS,
  MEASURE_TOKENS,
  SHADOW_TOKENS,
  LAYER_TOKENS,
  BUTTONS,
  RULE,
  FORBIDDEN,
  WHEN_IT_DOES_NOT_FIT,
  RECIPE,
  LESS_RULES,
  NOT_SHARED,
  SAMPLE_COLOURS,
  SAMPLE_SHARES
} from './catalogue'
import { PLAYLIST_COLOURS } from 'common/playlist-colour'
import './style-guide.component.less'

/**
 * The team keeps each file below about 5000 tokens. The page is larger, so
 * each group of sections has its own file. The page shell marks the place of
 * the sections with one element, and this module puts the groups there in page
 * order. The result is one template, so the DOM does not change.
 *
 * The replacement is a function because a string replacement reads $ as a
 * pattern, and the templates hold $ctrl.
 */
const SECTIONS_MARK = '<style-guide-sections></style-guide-sections>'
const SECTIONS = [
  require('./style-guide-foundations.tpl.html').default,
  require('./style-guide-surfaces.tpl.html').default,
  require('./style-guide-marks.tpl.html').default,
  require('./style-guide-controls.tpl.html').default
].join('\n')

class StyleGuideController {
  constructor () {
    'ngInject'

    this.colourTokens = COLOUR_TOKENS
    // This is the real list and not a copy, so the page cannot show an old colour.
    this.playlistColours = PLAYLIST_COLOURS
    this.fontTokens = FONT_TOKENS
    this.typeTokens = TYPE_TOKENS
    this.measureTokens = MEASURE_TOKENS
    this.shadowTokens = SHADOW_TOKENS
    this.layerTokens = LAYER_TOKENS
    this.buttons = BUTTONS
    this.rule = RULE
    this.forbidden = FORBIDDEN
    this.whenItDoesNotFit = WHEN_IT_DOES_NOT_FIT
    this.recipe = RECIPE
    this.lessRules = LESS_RULES
    this.notShared = NOT_SHARED
    this.sampleColours = SAMPLE_COLOURS
    this.sampleShares = SAMPLE_SHARES
  }
}

export default {
  controller: StyleGuideController,
  template: require('./style-guide.tpl.html').default.replace(SECTIONS_MARK, () => SECTIONS)
}

export { StyleGuideController }
